import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { GestorContenidoService } from 'src/app/services/gestor-contenido.service';

@Component({
    selector: 'app-articulos',
    templateUrl: './articulos.component.html',
    styles: [],
    standalone: false
})
export class ArticulosComponent implements OnInit {
  listaArticulos: any[] = [];
  listaAutores: any[] = [];
  listaEtiquetas: any[] = [];
  articulosForm: UntypedFormGroup;
  articulosPorFila: number = 3;
  filtroCategorias: any[] = [];
  filtroAutores: any[] = [];
  filtroEtiquetas: any[] = [];
  constructor(private formBuilder: UntypedFormBuilder,
    private _gestorContenido: GestorContenidoService) {
    window.scroll(0, 0);
    this.articulosForm = this.formBuilder.group({
      idNodo: null,
      titulo: '',
      body: '',
      etiquetas: '',
      categorias: '',
      usuario: '',
      fechaMax: '',
      fechaMin: '',
      pagina: null,
    });
  }

  ngOnInit(): void {
    this.getArticulosPorFiltros();
    this.getAutores();
    this.getEtiquetas();
  }

  getArticulosPorFiltros() {
    this.listaArticulos = [];
    this._gestorContenido.getArticulosPorFiltros(this.articulosForm.value).subscribe(
      (response: any) => {
        const page = response;
        for (let i = 0; i < page.rows.length; i += this.articulosPorFila) {
          const fila = page.rows.slice(i, i + this.articulosPorFila);
          this.listaArticulos.push(fila);
        }
      },
      (error) => {

      }
    );
  }

  getAutores() {
    this._gestorContenido.getAutores().subscribe(
      (response: any) => {
        const page = response;
        this.listaAutores = page.data;
      },
      (error) => {
      }
    );
  }

  getEtiquetas() {
    this._gestorContenido.getEtiquetas().subscribe(
      (response: any) => {
        const page = response;
        this.listaEtiquetas = page.data;
      },
      (error) => {
      }
    );
  }

  checkedCategorias(event, name) {
    if (event.target.checked) {
      this.filtroCategorias.push(name)
    } else {
      this.filtroCategorias.splice(this.filtroCategorias.find(item => item.value === name), 1);
    }
  }

  checkedAutores(event, name) {
    if (event.target.checked) {
      this.filtroAutores.push(name)
    } else {
      this.filtroAutores.splice(this.filtroAutores.find(item => item.value === name), 1);
    }
  }

  checkedEtiquetas(event, name) {
    if (event.target.checked) {
      this.filtroEtiquetas.push(name)
    } else {
      this.filtroEtiquetas.splice(this.filtroEtiquetas.find(item => item.value === name), 1);
    }
  }

  filtro() {
    const stringCategorias = this.filtroCategorias.join(', ');
    this.articulosForm.get("categorias").setValue(stringCategorias);

    const stringAutores = this.filtroAutores.join(', ');
    this.articulosForm.get("usuario").setValue(stringAutores);

    const stringEtiquetas = this.filtroEtiquetas.join(', ');
    this.articulosForm.get("etiquetas").setValue(stringEtiquetas);

    this.getArticulosPorFiltros();
  }

  transformarTitulo(titulo: string){
    return titulo.replace(/ /g, '_');
  }
}